// Angular
import { AbstractControl, ValidationErrors } from '@angular/forms';

export class FileValidator {
  static isValid(control: AbstractControl): ValidationErrors | null {
    console.log('isValid: ', control.value);
    if (!control.value || !control.value.length) return { fileRequired: true };
    return null;
  }
}
